// TODO: divide this module to investment and investmentList
export default function () {
  return {
    createModel: {},
    stepModels: {},
    investmentData: {},
    investmentDataLoading: false,
    investmentDataLoaded: false,
    investmentList: [],
    investmentListLoading: false,
    investmentListLoaded: false,
    reInitiateTransactionInvestmentListItemLoading: false,
    selectedProfileId: null,
    investmentSingleData: {},
    investmentSingleDataLoading: false,
    investmentListCompletedSuccessful: [],
    investmentListCompletedSuccessfulLoading: false,
    investmentListCompletedSuccessfulLoaded: false,
    investmentListExited: [],
    investmentListExitedLoading: false,
    investmentListExitedLoaded: false,
    investmentListOpenSummary: {},
    investmentListCompletedSummary: {},
    investmentListExitedSummary: {},
    // investment Documents (for banner)
    investmentsDocuments: {},
    investmentsDocumentsLoading: false,
    investmentsDocumentsLoaded: false,
    investmentListCounts: {},
    investmentPrivateToken: null,
  };
}
